import striptags from 'striptags';

// export type Message = {
//   id: string;
//   status: string;
//   type: string;
//   text?: string;
//   from?: string;
//   subject?: string;
//   conversationId?: number;
// };

// export type Question = {
//   input: string;
//   messageId: string;
// };

export function parseMessages(messages) {
  if (!messages || messages.length === 0) {
    return [];
  }

  //  messages = messages.slice(0, messages.length - 3);
  if (responseNotNeeded(messages)) {
    const index = findLatestInboundIndex(messages);
    if (index >= 0) {
      messages = messages.slice(0, index + 1);
    }
  }
  switch (messages[0].from.type) {
    case 'intercom':
      return parseIntercomm(messages);
    case 'email':
      return parseEmail(messages);
    default:
      return [];
  }
}

function parseHTMLIntercom(text) {
  return striptags(text);
}

function parseIntercomm(messages) {
  return messages.map((element) => {
    return {
      type: 'intercom',
      id: element.id,
      status: element.status,
      text: parseHTMLIntercom(element.content.body),
      contact: element.from.contact,
      handle: element.from.handle,
    };
  });
}

function parseEmail(messages) {
  return messages.map((element) => {
    return {
      type: 'email',
      id: element.id,
      status: element.status,
      contact: element.from.contact,
      handle: element.from.handle,
    };
  });
}

export function findLatestInboundMessage(messages) {
  let i = messages.length - 1;
  while (i >= 0) {
    if (messages[i].status === 'inbound') {
      return messages[i];
    }
    i -= 1;
  }
  return null;
}

export function findLatestInboundIndex(messages) {
  let i = messages.length - 1;
  while (i >= 0) {
    if (messages[i].status === 'inbound') {
      return i;
    }
    i -= 1;
  }
  return i;
}

export function intercomNoResponseNeeded(messages) {
  // User didn't not provide any information beyond intercom canned response
  if (messages.length <= 1) {
    return true;
  }

  // already resolved
  if (
    messages.find((message) => message.text.includes('That helped')) != null &&
    messages[messages.length - 1].status === 'outbound'
  ) {
    return true;
  }
  return false;
}

export function responseNotNeeded(messages) {
  if (!messages || messages.length === 0) {
    return true;
  }

  if (messages[messages.length - 1].status === 'outbound') {
    if (
      !messages[messages.length - 1].html ||
      !messages[messages.length - 1].html.includes(
        "This automated reply confirms that we've received your message",
      )
    ) {
      return true;
    }
  }
  return false;
}

export function convertUNIXToDate(ts) {
  // Create a new JavaScript Date object based on the timestamp
  // multiplied by 1000 so that the argument is in milliseconds, not seconds.
  const d = new Date(ts * 1000);
  // Will display time in 10:30:23 format
  return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
}

// Message is the latest outbound
export function findContacts(msg) {
  let contacts = [];
  if (msg.from != null) {
    contacts.push({
      handle: msg.from.handle,
      type: msg.from.type,
    });
  }
  if (msg.cc != null && msg.cc.length > 0) {
    msg.cc.forEach((m) => {
      if (
        !m.handle.includes('@usemotion.com') &&
        !m.handle.includes('@usemotion.app')
      ) {
        contacts.push({
          handle: m.handle,
          type: m.type,
        });
      }
    });
  }

  return contacts;
}

// Find the subscription that the user is referring to
// if there are non-cancelled, choose the first non-cancelled
// if there are all cancelled, choose the one that's cancelled the latest
export function findContactWithMentionedSubscription(contacts) {
  let numNonCancelled = 0;
  const subs = [];
  for (const contact of Object.values(contacts)) {
    if (contact.stripes != null) {
      for (const customer of contact.stripes) {
        if (
          customer.subscriptions.data != null &&
          customer.subscriptions.data.length > 0
        ) {
          for (const sub of customer.subscriptions.data) {
            if (sub.status !== 'canceled') {
              numNonCancelled += 1;
            }
            subs.push([contact, sub]);
          }
        }
      }
    }
  }
  if (numNonCancelled > 0) {
    return subs.find((entry) => entry[1].status !== 'canceled');
  } else {
    return subs[0];
  }
}
